import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import CronJobsList from '../components/cronJobs/CronJobsList';
import CreateCronJobModal from '../components/modals/cronJobs/CreateCronJobModal';
import DeleteCronJobModal from '../components/modals/cronJobs/DeleteCronJobModal';
import UpdateCronJobModal from '../components/modals/cronJobs/UpdateCronJobModal';
import { ICronJob } from '../models/ICronJob';
import InternalPage from './InternalPage';
import { useGetAllCronJobsQuery } from '../store/api/cronJobsApi';

const CronJobsPage = () => {

    const [createCronJobVisible, setCreateCronJobVisible] = useState(false);
    const [updateCronJobVisible, setUpdateCronJobVisible] = useState(false);
    const [deleteCronJobVisible, setDeleteCronJobVisible] = useState(false);
    const [cronJobToEdit, setCronJobToEdit] = useState<ICronJob | null>(null);
    const [cronJobToDelete, setCronJobToDelete] = useState<ICronJob | null>(null);

    const { data, isError, isFetching } = useGetAllCronJobsQuery(undefined, {
        refetchOnMountOrArgChange: true,
    });

    const onCronJobEdit = (cronJob: ICronJob) => {
        setCronJobToEdit(cronJob);
        setUpdateCronJobVisible(true);
    }

    const onCronJobDelete = (cronJob: ICronJob) => {
        setCronJobToDelete(cronJob);
        setDeleteCronJobVisible(true);
    }

    const onCronJobChangeSuccess = () => {
        setCreateCronJobVisible(false);
        setUpdateCronJobVisible(false);
        setDeleteCronJobVisible(false);
    }

    return (
        <InternalPage>
            <div className='title-block' style={{ backgroundImage: 'url(/static/img/title-bg-1.png)' }}>
                <h1>
                    Cron Jobs
                </h1>
            </div>

            <div className='main-content'>
                <Card className='w-100 p-3'>
                    <div className="mb-2">
                        <Button variant="success" style={{ float: 'right' }} onClick={() => setCreateCronJobVisible(true)}>Create new</Button>
                    </div>

                    {isFetching && <div>Loading...</div>}
                    {!isFetching && isError && <div>Oops. Somethins goes wrong.</div>}
                    {data && !isFetching && !isError && (
                        <CronJobsList
                            cronJobs={data}
                            onCronJobEdit={onCronJobEdit}
                            onCronJobDelete={onCronJobDelete}
                        />
                    )}
                </Card>
            </div>

            <CreateCronJobModal
                show={createCronJobVisible}
                onSuccess={onCronJobChangeSuccess}
                onHide={() => setCreateCronJobVisible(false)}
            />
            {cronJobToEdit && <UpdateCronJobModal
                cronJob={cronJobToEdit}
                show={updateCronJobVisible}
                onSuccess={onCronJobChangeSuccess}
                onHide={() => setUpdateCronJobVisible(false)}
            />}
            {cronJobToDelete && <DeleteCronJobModal
                cronJob={cronJobToDelete}
                show={deleteCronJobVisible}
                onSuccess={onCronJobChangeSuccess}
                onHide={() => setDeleteCronJobVisible(false)}
            />}
        </InternalPage>
    );
};

export default CronJobsPage;
